import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { jobTitleFromAudiencePivotAutoCompleteInput$, jobTitleFromAudiencePivotAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const JobTitleFromAudiencePivotAutoSuggest = renderAutoSuggestWithOptions(
   jobTitleFromAudiencePivotAutoCompleteObservable$,
   jobTitleFromAudiencePivotAutoCompleteInput$,
);

JobTitleFromAudiencePivotAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   filterOrganization: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search Job Title...',
};

export default JobTitleFromAudiencePivotAutoSuggest;
